export const environment = {
  production: true,
  url: "https://pgs.globalaccelerex.com.gh",
  accessControl: "https://pgs.ghana.globalaccelerex.com",
  callbackUrl: "https://enshrlk2nz7yd.x.pipedream.net/",
  appUser: "rexpay-ui",
  appPwd: "l1soVhZXeHIth2Z",
  notificationSender: "noreply@globalaccelerex.com",
  activationLink: "https://myrexpay.com/auth/resetPassword",
  paymentPageLink: "https://checkout.myrexpay.com/",
  ghPaymentPageLink: "https://checkout.myrexpay.com/gh/",
  documentService:
    "https://sandbox.globalaccelerex.com/api/accelerex-integrator/v1/business/upload",
  logoBaseUrl: "https://pgs.globalaccelerex.com",
  ghBaseUrl: "https://pgs.globalaccelerex.com.gh",
};
